import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCastroComponent } from './simple-icons-castro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCastroComponent ],
    exports:      [ SimpleIconsCastroComponent ],
    bootstrap:    []
})
export class SimpleIconsCastroModule {}
